import RulesAndRegulationsIcon from "../../assets/icons/more.svg";

const RulesAndRegulations = () => {
  return (
    <div className="mt-10">
      <div className="flex items-center">
        <img src={RulesAndRegulationsIcon} width={28} alt="قوانین و مقررات" />
        <h1 className="font-bold mr-3">
          قوانین و مقررات استفاده از خدمات پلتفرم تفسیر هوش مصنوعی آزمایش
          بادی‌بان
        </h1>
      </div>

      <div className="my-10">
        <p className="text-justify leading-7">
          <a href="https://bodybon.info" className="text-pr_primary">
            <strong> پلتفرم بادی‌بان </strong>
          </a>
          جهت افزایش دانش شما نسبت به داده‌های موجود در جواب آزمایش‌های
          پزشکی‌تان ایجاد شده است. شما با وارد کردن مشخصات اولیه، سن، جنسیت و
          بار‌گذاری تصویر یا فایل پی‌دی‌اف جواب آزمایش خود، می‌توانید جزئیات و
          علائم اختصاری برگه آزمایش‌تان را به زبان ساده و قابل فهم، در
          کوتاه‌ترین زمان، بخوانید و تفسیر کامل هوش مصنوعی آن را به همراه
          توصیه‌های تکمیلی لازم مشاهده کنید. اطلاعات موجود در پلتفرم بادی‌بان از
          دستورالعمل‌های معتبر پزشکی و براساس الگوریتم‌های هوش مصنوعی و
          پرامپت‌های اختصاصی و بهینه‌سازی‌شده استخراج شده است و سپس به تاکید
          پزشک متخصص رسیده است. ارتقای سطح بهداشت عمومی و توانمندسازی جامعه در
          راستای درک بهتر مفاهیم اولیه پزشکی، گامی مهم در جهت توسعه ایران است که
          پلتفرم بادی‌بان با افتخار برداشته است و به منظور تحقق کامل این هدف و
          ارائه ارزش‌های بیشتر به کاربران، تلاش بیشتری خواهد کرد. امیدواریم
          خدمات بادی‌بان، به کاهش هزینه‌های نظام سلامت در ایران کمک کند. در این
          بخش، شرح کاملی از قوانین و مقررات پلتفرم بادی‌بان برای استفاده بهتر
          کاربران آورده شده است و ورود کاربران به پلتفرم و ساخت پروفایل شخصی به
          معنای آگاهی و پذیرفتن شرایط و قوانین و مقررات است. لطفا این قوانین را
          به دقت مطالعه کنید.
        </p>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">رضایت و توافق کاربر</h2>
          <p className="text-justify leading-7">
            کاربر به شخصی گفته می‌شود که با ثبت اطلاعات کاربری خود، از خدمات
            پلتفرم بادی‌بان استفاده می‌کند. کابران پلتفرم بادی‌بان در حال حاضر
            شامل بیماران یا آزمایش‌دهندگانی هستند که تمایل به تفسیر آنلاین
            آزمایش پزشکی خود دارند.
          </p>
          <ul className="my-5 list-inside list-disc">
            <li className="my-2 text-justify">
              با استفاده از این پلتفرم، شما تأیید می‌کنید که حداقل ۱۸ سال دارید،
              یا در صورت زیر ۱۸ سال بودن، تحت نظارت و با رضایت سرپرست قانونی از
              پلتفرم استفاده می‌کنید.
            </li>
            <li className="my-2 text-justify">
              شما موافقت می‌کنید که اطلاعات دقیق، کامل و به‌روز را هنگام استفاده
              از پلتفرم ارائه دهید.
            </li>
            <li className="my-2 text-justify">
              شما موافقت می‌کنید که تصاویر واضح و دارای استاندارد و کیفیت مناسب
              را به منظور خوانش دقیق جواب آزمایش توسط سیستم پردازش تصویر هوش
              مصنوعی بادی‌بان بار‌گذاری می‌کنید.
            </li>
            <li className="my-2 text-justify">
              شما می‌پذیرید و آگاه هستید که تحلیل‌ها و توصیه‌های ارائه شده توسط
              هوش مصنوعی بادی‌بان، جنبه اطلاعاتی دارند و جایگزین مشاوره پزشکی
              حرفه‌ای، تشخیص یا درمان نمی‌شوند. برای هرگونه تصمیم‌گیری پزشکی
              همواره با پزشک یا متخصص مربوطه مشورت کنید.
            </li>
            <li className="my-2 text-justify">
              شما موافقت می‌کنید که از پلتفرم بادی‌بان در جهت بارگذاری داده‌هایی
              که حق قانونی برای اشتراک‌گذاری آن‌ها ندارید، بارگذاری محتواهای
              مخرب، نادرست، یا جعلی، بارگذاری محتواهای مخرب، نادرست یا جعلی،
              مهندسی معکوس یا استفاده غیرمجاز و اقداماتی که ممکن است به عملکرد
              پلتفرم یا تجربه کاربران آسیب برساند استفاده نمی‌کنید
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">
            بارگذاری و استفاده از داده‌ها
          </h2>

          <ul className="my-5 list-inside list-disc">
            <li className="my-2 text-justify">
              شما می‌توانید تصاویر یا فایل‌های PDF از نتایج آزمایشات پزشکی مختلف
              خود را از جمله آزمایش خون و دیگر آزمایشات تشخیصی برای تحلیل توسط
              هوش مصنوعی بارگذاری کنید.
            </li>
            <li className="my-2 text-justify">
              پلتفرم داده‌های ارائه شده توسط شما را پردازش و تحلیل می‌کند تا
              نتایج و پیشنهاداتی مبتنی‌بر هوش مصنوعی ارائه دهد.
            </li>
            <li className="my-2 text-justify">
              با بارگذاری نتایج آزمایشات خود، شما تأیید می‌کنید که حق قانونی
              برای به اشتراک‌گذاری این داده‌ها دارید و رضایت خود را برای تحلیل
              آن‌ها توسط هوش مصنوعی پلتفرم اعلام می‌کنید.
            </li>
            <li className="my-2 text-justify">
              پلتفرم بادی‌بان ادعای مالکیت بر تصاویر یا فایل‌های بارگذاری‌شده و
              حق انتشار آن را ندارد؛ اما برای ارائه خدمات بهتر به کاربران و در
              راستای توسعه قابلیت‌های پلتفرم از داده‌های بارگذاری‌شده استفاده
              می‌کند.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">
            حریم خصوصی و امنیت داده‌ها
          </h2>

          <ul className="my-5 list-inside list-disc">
            <li className="my-2 text-justify">
              پلتفرم بادی‌بان متعهد به حفاظت از حریم خصوصی شماست. تمام داده‌های
              آزمایشات پزشکی و اطلاعات شخصی شما به صورت ایمن ذخیره می‌شود و بدون
              رضایت صریح شما هرگز به اشخاص ثالث ارائه نمی‌گردد.
            </li>
            <li className="my-2 text-justify">
              شما می‌توانید در هر زمان درخواست حذف داده‌های خود را از طریق تماس
              با بادی‌بان از طریق ایمیل
              <a href="mailto:support@bodybon.info" className="text-pr_primary">
                <strong> support@bodybon.info </strong>
              </a>
              اعلام کنید.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">
            محدودیت‌های هوش مصنوعی
          </h2>

          <ul className="my-5 list-inside list-disc">
            <li className="my-2 text-justify">
              تحلیل‌های ارائه شده توسط هوش مصنوعی فقط بر اساس داده‌های ارائه شده
              توسط شما انجام می‌شود و باید به عنوان اطلاعات کمکی در نظر گرفته
              شوند. این پلتفرم تشخیص پزشکی یا توصیه‌های درمانی ارائه نمی‌دهد.
            </li>
            <li className="my-2 text-justify">
              توصیه‌ها و تحلیل‌ها ممکن است به شما کمک کنند تا موضوعات مرتبط با
              سلامت خود را بهتر درک کنید؛ اما جایگزین مشاوره مستقیم با پزشکان و
              متخصصین نمی‌شوند.
            </li>
            <li className="my-2 text-justify">
              هرگونه تصمیم‌گیری در مورد سلامت و درمان که بر اساس نتایج هوش
              مصنوعی انجام می‌دهید، مسئولیت خودتان است و توصیه می‌شود قبل از
              هرگونه اقدام، با یک متخصص پزشکی مشورت کنید.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">
            سلب مسئولیت و محدودیت‌های مسئولیت
          </h2>

          <ul className="my-5 list-inside list-disc">
            <li className="my-2 text-justify">
              پلتفرم بادی‌بان در مراحل اولیه و فاز ابتدائی فعالیت، تضمینی در
              مورد بی‌وقفه بودن و بدون خطا بودن نمی‌دهد.
            </li>
            <li className="my-2 text-justify">
              تا حداکثر میزان مجاز تحت قوانین، پلتفرم تمام ضمانت‌ها، شامل
              ضمانت‌های دقت، قابلیت اعتماد، مناسب بودن برای هدف خاص یا عدم نقض
              حقوق دیگران را سلب می‌کند.
            </li>
            <li className="my-2 text-justify">
              کاربران باید توجه داشته باشد که استفاده از خدمات پلتفرم بادی‌بان
              به هیچ عنوان برای موارد اورژانسی، تشخیص بالینی، تجویز دارو و ویزیت
              نمی‌باشد و جنبه مشاوره دارد و در صورت ایجاد هرگونه مشکل بالینی
              برای کاربر در طی درمان، پلتفرم بادی‌بان هیچ‌گونه مسئولتی ندارد.
            </li>
            <li className="my-2 text-justify">
              ما هیچ مسئولیتی در قبال خسارت‌های مستقیم، غیرمستقیم، تصادفی یا
              تبعی که ناشی از استفاده یا ناتوانی در استفاده از پلتفرم باشد، حتی
              اگر از امکان وقوع چنین خساراتی آگاه شده باشیم، نداریم.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">مالکیت معنوی</h2>

          <ul className="my-5 list-inside list-disc">
            <li className="my-2 text-justify">
              تمام فناوری‌ها، مدل‌های هوش مصنوعی، نرم‌افزارها و محتوای استفاده
              شده در این پلتفرم، دارایی معنوی پلتفرم یا مجوزدهندگان آن است. شما
              مجاز به کپی‌برداری، تغییر، توزیع یا مهندسی معکوس هیچ بخشی از
              پلتفرم نیستید.
            </li>
            <li className="my-2 text-justify">
              نام، علائم تجاری، لوگوها و برندینگ پلتفرم تحت قوانین مربوط به
              مالکیت معنوی محافظت می‌شوند و استفاده غیرمجاز از آن‌ها ممنوع است.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">
            تغییرات در پلتفرم و شرایط
          </h2>

          <ul className="my-5 list-inside list-disc">
            <li className="my-2 text-justify">
              پلتفرم بادی‌بان حق تغییر، تعلیق یا توقف هر بخش یا خدمت بدون اطلاع
              قبلی را برای خود محفوظ می‌دارد.
            </li>
            <li className="my-2 text-justify">
              پلتفرم بادی‌بان ممکن است این قوانین و مقررات را هر زمان
              به‌روزرسانی کند. هرگونه تغییر در این قوانین از طریق پلتفرم اعلام
              خواهد شد و ادامه استفاده شما از پلتفرم به منزله پذیرش شرایط جدید
              است.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">خاتمه استفاده</h2>

          <ul className="my-5 list-inside list-disc">
            <li className="my-2 text-justify">
              پلتفرم بادی‌بان حق دارد دسترسی هر کاربری را که قوانین را نقض کند
              یا درگیر رفتارهای غیرقانونی یا مخرب باشد، متوقف یا خاتمه دهد.
            </li>
            <li className="my-2 text-justify">
              کاربران می‌توانند در هر زمان حساب کاربری خود را غیرفعال کرده و
              درخواست حذف داده‌های شخصی خود را از طریق تماس با پشتیبانی مشتریان
              ارسال کنند.
            </li>
          </ul>
        </div>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">مقالات و محتوا</h2>

          <p className="text-justify leading-7">
            پلتفرم بادی‌بان، برای تولید محتوای صحیح در بستر سایت و شبکه‌های
            اجتماعی از منابع و مراجع علمی معتبر از جمله
            <strong>WHO، PubMed، CLSI</strong> و … استفاده می‌کند.
          </p>
        </div>

        <div>
          <h2 className="font-bold text-lg mb-2 mt-10">
            ارتباط با پلتفرم بادی‌بان
          </h2>

          <p className="text-justify leading-7">
            شما در صورت هرگونه سوال، نگرانی یا درخواست مربوط به داده‌های شخصی یا
            استفاده از پلتفرم، می‌توانید از طریق
            <a href="mailto:support@bodybon.info" className="text-pr_primary">
              <strong> support@bodybon.info </strong>
            </a>
            با ما در ارتباط باشید. شما به پلتفرم بادی‌بان اجازه می‌دهید که از
            طریق بستر دیجیتال شامل پست الکترونیکی، سرویس پیام کوتاه و سایر خدمات
            الکترونیکی به درخواست و سوالات شما پاسخ دهد یا با شما در ارتباط
            باشد. ایمیل و شماره تماس ثبت شده در پروفایل کاربر، تنها ایمیل و
            شماره تماس رسمی و مورد تایید پلتفرم بادی‌بان است و تمام مکاتبات از
            طریق راه‌های ارتباطی درج‌شده در پروفایل کاربر صورت می‌گیرد و
            بادی‌بان نسبت به شماره تماس و ایمیل‌های دیگر مسئولیتی نمی‌پذیرد. با
            استفاده از این پلتفرم، شما تأیید می‌کنید که این قوانین و مقررات را
            خوانده و با آن‌ها موافقت کرده‌اید. رعایت این قوانین تضمین‌کننده
            امنیت، یکپارچگی و کیفیت خدمات بادی‌بان است.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RulesAndRegulations;
